<template>
  <div>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >

    <Table
      border
      row-key="id"
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-row-click="$emit('obj', $event)"
    >
      <AddressList
        slot-scope="{ row, index }"
        slot="addressS"
        :list="row.pickupAddress"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <AddressList
        slot-scope="{ row, index }"
        slot="addressD"
        :list="row.unloadAddress"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openAdd(row, index)">分单</Button>
        <Button size="small" @click="bufendan(row, index)">不分单</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增分单配载' : '编辑分单配载'"
      width="1000"
      ref="formModel"
      @tab="now = $event"
      fullscreen
    >
      <Input
        v-model="item.ono"
        placeholder="请选择"
        slot="ono"
        @on-focus="openForm = true"
        readonly
      ></Input>
      <tableForm
        slot="transportGoodsList"
        ref="transportGoodsList"
        :forms="transportGoodsListForms"
        :item1="transportGoodsListItem"
        :noFirst="true"
        v-model="item.list"
        height="360"
      >
      </tableForm>

      <Button slot="btn" type="primary" @click="addUpdate">确认分单</Button>
    </form-model>
  </div>
</template>
<script>
var ordersGoodsList = [],
  list1 = [],
  list2 = [];

export default {
  props: ["scan"],
  data() {
    return {
      isAdd: false,
      openForm: false,
      now: "基本信息",
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "订单号",
          key: "no",
          width: 150,
          tree: true,
        },
        {
          title: "创建时间",
          key: "createTime2",
          width: 130,
          tree: true,
        },
        {
          title: "订单状态",
          key: "status2",
        },
        {
          title: "卡板数",
          key: "pnumber",
        },
        {
          title: "数量/件",
          key: "amount",
          required: false,
          val: 0,
        },
        {
          title: "重量kg",
          key: "weight",
          required: false,
          val: 0,
        },
        {
          title: "体积(立方)",
          key: "volume",
          required: false,
        },
        {
          title: "提货地点",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          slot: "addressS",
          required: true,
          readonly: false,
          noUpdate: true,
          width: 300,
          type: "AddressList",
          span: 8,
        },
        {
          title: "卸货地点",
          key: "addressD",
          slot: "addressD",
          keyX: "xd",
          keyY: "yd",
          width: 300,
          required: true,
          readonly: false,
          noUpdate: true,
          type: "AddressList",
          span: 8,
        },
        {
          title: "口岸",
          key: "portsName",
        },
        {
          title: "业务类型",
          key: "bpMode2",
        },

        {
          title: "六联单号",
          key: "sixOno",
          sort: 10,
        },
        {
          title: "车辆类型",
          key: "carType",
          sort: 11,
        },

        {
          title: "始发时间",
          key: "timeS2",
          width: 150,
          sort: 13,
        },
        {
          title: "到达时间",
          key: "timeD2",
          required: false,
          width: 150,
          sort: 15,
        },

        {
          title: "品名",
          key: "name",
          required: false,
          val: "",
          sort: 18,
        },
        {
          title: "入仓仓库",
          key: "storeName",
          required: false,
          val: "",
          sort: 19,
        },
        {
          title: "条形码",
          key: "barCode",
          required: false,
          val: "",
          sort: 20,
        },

        {
          title: "型号",
          key: "model",
          required: false,
          val: "",
          sort: 22,
        },

        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          sort: 25,
        },
        {
          title: "是否存仓",
          key: "isStore2",
          required: false,
          sort: 26,
        },
        {
          title: "调度员",
          key: "dispatcher",
          required: false,
          val: "",
          sort: 27,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 120,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        ono: "",
        list: ordersGoodsList,
      },
      transportGoodsListForms: [
        {
          title: "卡板数P/L",
          key: "pnumber",
          required: true,
          val: "",
          type: "InputNumber",
        },
        {
          title: "体积/cbm",
          key: "volume",
          required: true,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
          required: true,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "数量/件",
          key: "amount",
          required: true,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "始发地",
          key: "addressS",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("addressPrice"),
        },
        {
          title: "目的地",
          key: "addressD",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("addressPrice"),
        },
        {
          title: "提货地址",
          key: "pickupAddress",
          required: true,
          width: 300,
          type: "AddressList",
          list1,
          list2,
        },
        {
          title: "卸货地址",
          key: "unloadAddress",
          required: true,
          width: 300,
          type: "AddressList",
          list1,
          list2,
        },
        {
          title: "贸易类型",
          key: "tradeType",
          required: true,
          val: "",
          type: "Select",
          selectItems: this.lydic.tradeType,
        },
        {
          title: "车辆类型",
          key: "carType",
          required: true,
          val: "",
          type: "Select",
          selectItems: this.lydic.getA("cartype"),
        },

        {
          title: "送货时间",
          key: "sendTime",
          required: true,
          val: "",
          type: "lyyymmdd",
        },
        {
          title: "装货时间",
          key: "shipmentTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
        },

        {
          title: "封条号",
          key: "sealNo",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "柜号",
          key: "cabinetNo",
          required: false,
          val: "",
          type: "Input",
        },

        {
          title: "型号",
          key: "model",
          required: false,
          val: "",
          type: "Input",
        },

        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      transportGoodsListItem: {
        pnumber: 1,
        xp: 0,
        xu: 0,
        yp: 0,
        yu: 0,
        //id: 0,
        //pageNumber: 0,
        //pageSize: 0,
        ono: "", //
        customer: "", //
        cid: "", //
        sealNo: "", //
        addressS: "", //
        addressD: "", //
        cabinetNo: "", //
        tradeType: "",
        carType: "",
        volume: 0,
        model: "",
        amount: 1,
        weight: 0,
        pickupAddress: [],
        sendTime: "",
        shipmentTime: Date.now() + 86400000 * 1,
        unloadAddress: [],
        remark: "",
        //extendFields: "",
        //filesPath: "",
        //keyWork: "",
        //idList: [],
      },
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: new Date(2023, 4, 1).getTime(),
        endTime: new Date(2023, 6, 1).getTime(),
        no: "",
        carNo: "",
        driver: "",
        sixOno: "",
        carType: "",
        addressD: "",
        addressS: "",
        //status: -1, //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "主订单",
          key: "ono",
          type: "Input",
          required: true,
          readonly: true,
          noTable: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "订单配载",
          key: "list",
          slotForm: "transportGoodsList",
          required: true,
          noTable: true,
          hideLabel: true,
          span: 24,
          fenlei: "订单配载",
        },
      ],
      searchForms: [
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "运单号",
          key: "tno",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/listPdpzAwati",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);

        for (let i = 0; i < data.length; i++) {
          data[i].sendDate2 = this.utils.time(data[i].sendDate, "yymmdd");
          data[i].isTax2 = this.$t("bool." + data[i].isTax);
          data[i].isTransfers2 = this.$t("bool." + data[i].isTransfers);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          data[i].shipmentTime2 = this.utils.time(
            data[i].shipmentTime,
            "yymmddhhmm"
          );
          data[i].sendTime2 = this.utils.time(data[i].sendTime, "yymmddhhmm");
          data[i].createTime2 = this.utils.time(data[i].createTime, "yymmddhhmm");
          data[i].status2 = this.lydic.getVal("orderStatus", data[i].status); 
          for (let j = 0; j < data[i].ordersFdpzList.length; j++) {
            data[i].ordersFdpzList[j].status2 = this.lydic.getVal(
              "orderStatus",
              data[i].ordersFdpzList[j].status
            );
          }
          data[i].children = data[i].ordersFdpzList;
          data[i]._disabled = data[i].ordersFdpzList.length > 0 ? true : false;
          data[i].pickupAddress = pick(data[i].ordersGoodsList);
          data[i].unloadAddress = unLoad(data[i].ordersUnGoodsList); 

          var t = data[i].ordersGoodsList;
          var pnumber = 0,
            amount = 0,
            weight = 0,
            volume = 0,
            pnumbers = [],
            amounts = [],
            weights = [],
            volumes = [],
            name = [];
          for (let j = 0; j < t.length; j++) {
            pnumber += t[j].pnumber;
            weight += t[j].weight;
            volume += t[j].volume;
            amount += t[j].amount;
            pnumbers.push(t[j].pnumber);
            amounts.push(t[j].amount);
            weights.push(t[j].weight);
            volumes.push(t[j].volume);
            name.push(t[j].name);
            t[j].pickupTime2 = this.utils.time(t[j].pickupTime, "yymmddhhmm");
          }
          data[i].pnumber = pnumber;
          data[i].amount = amount;
          data[i].weight = weight;
          data[i].volume = volume;

          data[i].pnumbers = pnumbers;
          data[i].amounts = amounts;
          data[i].weights = weights;
          data[i].volumes = volumes;

          data[i].name = name.join(",");
          var t = data[i].ordersCustomsList;
          var ports = [];
          /* for (let j = 0; j < t.length; j++) {
            if (!ports.includes(t[j].ckPor)) {
              ports.push(t[j].ckPort);
            }
          } */
          data[i].ports = ports;
          data[i].portsName = ports.join(",");
        }
        function pick(v) {
          var arr = [];
          for (let i = 0; i < v.length; i++) {
            var t = v[i].pickupAddress;
            for (let j = 0; j < t.length; j++) {
              arr.push(t[j]);
            }
          }

          return arr;
        }
        function unLoad(v) {
          var arr = [];

          for (let i = 0; i < v.length; i++) {
            var t = v[i].receiveAddress;
            for (let j = 0; j < t.length; j++) {
              arr.push(t[j]);
            }
          }
          return arr;
        }
        function cacu(v, type) {
          var pnumber = 0,
            amount = 0;
          for (let i = 0; i < v.length; i++) {
            pnumber += v[i].pnumber;
            amount += v[i].amount;
          }
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        var table = this.$refs.transportGoodsList.yanzheng();

        if (table != true) {
          this.$Message.error(table);
          return;
        }
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/ordersFdpz/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/ordersFdpz/update",
          data: this.transportGoodsListItem,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    bufendan(row, n) {
      this.$Modal.confirm({
        title: "确定不需要分单配载？",
        //content: "确认后将在",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-omc/orders/updateFdpz",
            data: { isFdfz: 0, no: row.no },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.transportGoodsListItem = JSON.parse(JSON.stringify(row));
      //console.log(this.transportGoodsListItem);
      this.$refs.formModel.reach(
        this.transportGoodsListForms,
        this.transportGoodsListItem
      );
    },
    openAdd(row) {
      this.isAdd = true;
      this.reobj(row);
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },

    reobj(v) {
      this.item.ono = v.no;
      this.openForm = false;
      ordersGoodsList.length = 0;
      list1.length = 0;
      list2.length = 0;
      for (let i = 0; i < v.unloadAddress.length; i++) {
        list2.push(v.unloadAddress[i]);
      }
      for (let i = 0; i < v.pickupAddress.length; i++) {
        list1.push(v.pickupAddress[i]);
        //
        var obj = {
          pnumber: v.pnumbers[i],
          amount: v.amounts[i],
          weight: v.weights[i],
          volume: v.volumes[i],
          name: v.name,
          ono: v.no,
          cid: v.cid,
          customer: v.customer,
          sealNo: v.sealNo,
          addressS: v.addressS,
          addressD: v.addressD,
          cabinetNo: v.cabinetNo,
          tradeType: v.tradeType,
          carType: v.carType,
          pickupAddress: [v.pickupAddress[i]],
          sendTime: Date.now() + 86400000 * 1.2,
          shipmentTime: Date.now() + 86400000 * 1,
          unloadAddress: [
            v.unloadAddress[i] ? v.unloadAddress[i] : v.unloadAddress[0],
          ],
          remark: "",
        };
        ordersGoodsList.push(JSON.parse(JSON.stringify(obj)));
      }
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    //this.dingdanhao();
    //console.log(this.lydic);
    /* setTimeout(() => {
      console.log(this.lydic.getA("addressPrice"));
    }, 2000); */

    // console.log(this.forms[8]);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/fendanpeizai1.vue